import * as React from 'react';
import { connect } from 'react-redux';

import { Button, Paper, Typography } from '@material-ui/core';
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles
} from '@material-ui/core/styles';

import * as UserActions from '@actions/UserActions';
import { logEvent } from '@api/analytics';
import { IStore, IUserState } from '@reducers';

const mapDispatchToProps = {
  patchUser: UserActions.patchUser.request,
  toggleAuthModal: UserActions.toggleAuthModal
};

const styles = (theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(6),
      marginLeft: 'auto',
      marginRight: 'auto',
      maxWidth: theme.breakpoints.values.sm,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
    paper: {
      backgroundColor: theme.palette.background.default,

      textAlign: 'center',
      padding: theme.spacing(4)
    },
    signUpText: {
      marginBottom: theme.spacing(3)
    }
  });

export const SignUpForm: React.FC<typeof mapDispatchToProps &
  WithStyles<typeof styles> &
  IUserState> = ({ isFetching, classes, toggleAuthModal }) => {
  React.useEffect(() => {
    logEvent({
      category: 'User',
      action: 'Viewed User Sign up Page'
    });
  }, []);

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <Typography variant="h4" gutterBottom>
          {"You're one step away"}
        </Typography>

        <Typography variant="body1" className={classes.signUpText}>
          Get a feel for this neighborhood - sign up or log in to view this
          micromarket report.
        </Typography>

        <Button
          id="sign-up-ok-btn"
          onClick={() =>
            toggleAuthModal({
              showModal: 'signup'
            })
          }
          variant="contained"
          size="large"
          color="secondary"
          disabled={isFetching}
        >
          {'Sign Up for Free'}
        </Button>
      </Paper>
    </div>
  );
};

const mapStateToProps = (state: IStore): IUserState => state.user;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(SignUpForm));
